import { useMemo } from 'react'

import { Card, CardContent, CardHeader, CardTitle } from '@/common/ui/card'
import useQueryGetTransactionSummary from '@/modules/dashboard/api/hooks/useQueryGetTransactionSummary'
import TransactionSummaryTable from '../TransactionSummaryTable'
import { useDateFilter } from '@/common/hooks/useDateFilter'

export default function TransactionSummaryListing() {
	const { dateFilter } = useDateFilter()

	const payload = {
		startDate: dateFilter.startDate
			? `${dateFilter.startDate}T00:00:00.000Z`
			: undefined,
		endDate: dateFilter.endDate
			? `${dateFilter.endDate}T00:00:00.000Z`
			: undefined,
	}

	const { data, isLoading } = useQueryGetTransactionSummary(payload)

	// Summary cards data
	const summaryCards = useMemo(() => {
		if (!data) return []

		return [
			{
				title: 'จำนวนธุรกรรม',
				value: data.totalSuccessTransaction,
				format: 'number',
			},
			{
				title: 'ยอดเทิร์น',
				value: data.totalTurnOver,
				format: 'currency',
			},
			{
				title: 'ยอดโอนเข้า',
				value: data.totalTransferIn,
				format: 'currency',
				color: 'text-green-600',
			},
			{
				title: 'ยอดโอนออก',
				value: data.totalTransferOut,
				format: 'currency',
				color: 'text-red-600',
			},
			{
				title: 'เรากินลูกค้า (โอนเข้า - โอนออก)',
				value: data.totalTransferIn - data.totalTransferOut,
				format: 'currency',
				color: 'text-green-600',
			},
			{
				title: 'ยอดเดิมพัน',
				value: data.totalBetAmount,
				format: 'currency',
			},
			{
				title: 'ยอดจ่าย',
				value: data.totalSettleAmount,
				format: 'currency',
			},
			{
				title: 'คอมมิชชั่น',
				value: data.totalCommission,
				format: 'currency',
			},
		]
	}, [data])

	const formatValue = (value: number, format: string) => {
		if (format === 'currency') {
			return `฿${value.toLocaleString()}`
		}
		return value.toLocaleString()
	}

	return (
		<div className="space-y-6">
			{/* Summary Cards */}
			<div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
				{summaryCards.map((card, index) => (
					<Card key={index}>
						<CardHeader className="pb-3">
							<CardTitle className="text-sm font-medium text-muted-foreground">
								{card.title}
							</CardTitle>
						</CardHeader>
						<CardContent className="pt-0">
							<div
								className={`text-2xl font-bold ${
									card.color || 'text-foreground'
								}`}
							>
								{formatValue(card.value, card.format)}
							</div>
						</CardContent>
					</Card>
				))}
			</div>

			{/* Provider Table */}
			<Card>
				<CardHeader>
					<CardTitle>สรุปตามผู้ให้บริการ</CardTitle>
				</CardHeader>
				<CardContent>
					<TransactionSummaryTable
						data={data?.summaryByProvider || []}
						isLoading={isLoading}
					/>
				</CardContent>
			</Card>
		</div>
	)
}
